
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/submit-article",
      function () {
        return require("private-next-pages/blog/submit-article/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/submit-article"])
      });
    }
  